import React, { createContext, useContext, useState, useCallback } from "react";

export const translations = {
  it: {
    nav: { about: "Azienda", services: "Lavorazioni", finishes: "Finiture", machinery: "Tecnologia", sectors: "Settori", work: "Galleria", contact: "Contatti" },
    hero: {
      since: "Dal 1970 — Made in Italy",
      lines: ["Precisione", "sul metallo,", "dal 1970."],
      sub: "Olmi Srl. Pulitura, lucidatura, smerigliatura, satinatura e assemblaggio di alta precisione su alluminio, ottone, zama e acciaio inox.",
      cta: "Richiedi un preventivo",
      cta2: "Scopri le lavorazioni",
    },
    marquee: "MADE IN ITALY • LAVORAZIONI DI ALTA PRECISIONE • DAL 1970 • PULITURA • LUCIDATURA • SMERIGLIATURA • SATINATURA • ASSEMBLAGGIO • ",
    whatsapp: { label: "Scrivici su WhatsApp", msg: "Buongiorno, vorrei informazioni sui vostri servizi di lavorazione metalli." },
    about: {
      overline: "01 — Chi Siamo",
      title: "Un'eredità di eccellenza, guidata dalla qualità.",
      p1: "Fondata nel 1970 dal Sig. Giovanni Olmi a Brignano Gera d'Adda, la Olmi Srl è poi passata al figlio Renato Olmi ed è oggi guidata dal nipote Cristiano Olmi. Tre generazioni della stessa famiglia dedicate a lavorazioni di alta precisione su componenti in metallo per arredamento, accessori bagno, ciclismo, automotive e nautica.",
      p2: "La qualità prima di tutto. Questo principio guida ogni nostra attività e collaborazione, inclusa quella con aziende leader nella produzione di protesi umane, dove precisione e perfezione sono fondamentali — onorando il prestigio del Made in Italy.",
      heritageTitle: "Tre generazioni",
      heritage: [
        { y: "1970", t: "Giovanni Olmi", d: "Fonda l'azienda a Brignano Gera d'Adda, dando inizio alla tradizione di famiglia." },
        { y: "2ª gen.", t: "Renato Olmi", d: "Il figlio di Giovanni raccoglie l'eredità e porta avanti l'azienda con la stessa dedizione." },
        { y: "Oggi", t: "Cristiano Olmi", d: "Il nipote di Giovanni e figlio di Renato guida l'azienda nella terza generazione." },
      ],
      stats: [
        { n: "1970", l: "Anno di fondazione" },
        { n: "4", l: "Robot di lavorazione" },
        { n: "6+", l: "Settori serviti" },
        { n: "100%", l: "Controllo qualità" },
      ],
    },
    services: {
      overline: "02 — Servizi & Lavorazioni",
      title: "Una gamma completa di lavorazioni.",
      items: [
        { n: "01", t: "Assemblaggio personalizzato", d: "Area dedicata e isolata per assemblaggi complessi e precisi, con controllo e test per garantire funzionalità e qualità finale secondo le specifiche del cliente." },
        { n: "02", t: "Rullatura & Timbratura", d: "Lavorazioni meccaniche per garantire finiture speciali e marcature precise sui componenti, con attenzione maniacale al dettaglio." },
        { n: "03", t: "Valvole pneumatiche", d: "Lavorazioni su valvole pneumatiche e componenti speciali con macchinari di ultima generazione per risultati eccellenti." },
        { n: "04", t: "Inserimento sfere & Montaggio", d: "Inserimento sfere e montaggio dei componenti secondo le specifiche del cliente, con precisione e attenzione al dettaglio." },
        { n: "05", t: "Servizi logistici", d: "Ritiro e consegna del materiale con mezzi aziendali o corrieri di fiducia, garantendo sicurezza e tempistiche ottimali." },
      ],
    },
    finishes: {
      overline: "03 — Finiture",
      title: "L'arte della finitura sul metallo.",
      items: [
        { t: "Smerigliatura", d: "Rimozione del materiale tramite abrasivi, con tecnologie all'avanguardia per risultati precisi e di alta qualità." },
        { t: "Satinatura", d: "Finitura superficiale dall'aspetto opaco e satinato, uniforme e di alta qualità su un'ampia gamma di materiali." },
        { t: "Lucidatura", d: "Superficie liscia e riflettente ottenuta con tecniche avanzate, per una finitura di alta precisione." },
        { t: "Pulitura", d: "Rimozione di contaminanti e impurità dalla superficie dei materiali con metodologie e prodotti sicuri ed efficaci." },
      ],
    },
    sampling: {
      tag: "Collaboriamo",
      title: "Campionatura gratuita.",
      text: "Vuoi valutare la nostra qualità e precisione? Ti offriamo una campionatura gratuita dei nostri servizi, senza alcun impegno.",
      cta: "Richiedi la campionatura",
    },
    machinery: {
      overline: "04 — Tecnologia & Parco Macchinari",
      title: "Qualità sopra la quantità. Sempre.",
      p: "Poniamo la qualità al di sopra della quantità, ma siamo attrezzati per rispondere anche a esigenze produttive elevate. Disponiamo di un tecnico-tornitore interno per pinze e stampi personalizzati, utilizzabili sia per i nostri 4 Robot che per lavorazioni manuali.",
      features: [
        "4 Robot di lavorazione automatizzata",
        "Tecnico-tornitore interno per pinze e stampi su misura",
        "Controlli qualitativi individuali su ogni articolo",
        "Area isolata per assemblaggi delicati e ambienti controllati",
      ],
    },
    sectors: {
      overline: "05 — Settori Serviti",
      title: "Partner di aziende leader.",
      list: ["Arredamento", "Accessori Bagno", "Ciclo & Motociclo", "Automotive", "Nautica", "Protesi Medicali"],
    },
    work: {
      overline: "06 — La Nostra Officina",
      title: "Il lavoro parla da sé.",
    },
    contact: {
      overline: "07 — Contatti",
      title: "Costruiamo qualcosa di preciso.",
      sub: "Per informazioni o per discutere una collaborazione, contattate direttamente Cristiano Olmi.",
      name: "Nome e cognome",
      email: "Email",
      company: "Azienda",
      phone: "Telefono",
      message: "Il tuo messaggio",
      send: "Invia richiesta",
      sending: "Invio in corso...",
      success: "Richiesta inviata! Ti risponderemo al più presto.",
      error: "Invio non riuscito. Riprova o chiamaci direttamente.",
      directTitle: "Contatti diretti",
      addressLabel: "Sede",
      address: "Via Baccanello, 35 · 24030 Terno d'Isola (BG), Italia",
    },
    footer: { rights: "Tutti i diritti riservati.", tagline: "Lavorazioni di alta precisione dal 1970.", download: "Scarica Company Profile" },
  },
  en: {
    nav: { about: "Company", services: "Services", finishes: "Finishing", machinery: "Technology", sectors: "Sectors", work: "Gallery", contact: "Contact" },
    hero: {
      since: "Since 1970 — Made in Italy",
      lines: ["Precision", "in metal,", "since 1970."],
      sub: "Olmi Srl. High-precision cleaning, polishing, grinding, satin-finishing and assembly of aluminium, brass, zamak and stainless steel.",
      cta: "Request a quote",
      cta2: "Explore our services",
    },
    marquee: "MADE IN ITALY • HIGH-PRECISION MACHINING • SINCE 1970 • CLEANING • POLISHING • GRINDING • SATIN FINISHING • ASSEMBLY • ",
    whatsapp: { label: "Message us on WhatsApp", msg: "Hello, I'd like information about your metal finishing services." },
    about: {
      overline: "01 — About Us",
      title: "A legacy of excellence, driven by quality.",
      p1: "Founded in 1970 by Mr. Giovanni Olmi in Brignano Gera d'Adda, Olmi Srl later passed to his son Renato Olmi and is today led by his grandson Cristiano Olmi. Three generations of the same family dedicated to high-precision machining of metal components for furniture, bathroom fittings, cycling, automotive and nautical sectors.",
      p2: "Quality above all. This principle guides every activity and collaboration, including those with leading companies in human prosthetics manufacturing, where precision and perfection are essential — honouring the prestige of Made in Italy.",
      heritageTitle: "Three generations",
      heritage: [
        { y: "1970", t: "Giovanni Olmi", d: "Founds the company in Brignano Gera d'Adda, beginning the family tradition." },
        { y: "2nd gen.", t: "Renato Olmi", d: "Giovanni's son takes up the legacy and carries the company forward with the same dedication." },
        { y: "Today", t: "Cristiano Olmi", d: "Giovanni's grandson and Renato's son now leads the company into its third generation." },
      ],
      stats: [
        { n: "1970", l: "Founded" },
        { n: "4", l: "Machining robots" },
        { n: "6+", l: "Sectors served" },
        { n: "100%", l: "Quality control" },
      ],
    },
    services: {
      overline: "02 — Services & Machining",
      title: "A complete range of processes.",
      items: [
        { n: "01", t: "Custom assembly", d: "A dedicated, isolated area for complex, precise assemblies, with control and testing to guarantee functionality and final quality to client specifications." },
        { n: "02", t: "Rolling & Stamping", d: "Mechanical processing for special finishes and precise markings on components, with meticulous attention to detail." },
        { n: "03", t: "Pneumatic valves", d: "Machining of pneumatic valves and special components using latest-generation equipment for excellent results." },
        { n: "04", t: "Ball insertion & Assembly", d: "Ball insertion and component assembly to client specifications, with precision and attention to detail." },
        { n: "05", t: "Logistics services", d: "Material pickup and delivery with company vehicles or trusted couriers, ensuring safety and optimal timing." },
      ],
    },
    finishes: {
      overline: "03 — Finishing",
      title: "The art of finishing metal.",
      items: [
        { t: "Grinding", d: "Material removal through abrasives, with cutting-edge technology for precise, high-quality results." },
        { t: "Satin-finishing", d: "A surface finish with a matte, satin appearance — uniform and high-quality across a wide range of materials." },
        { t: "Polishing", d: "A smooth, reflective surface achieved with advanced techniques for a high-precision finish." },
        { t: "Cleaning", d: "Removal of contaminants and impurities from material surfaces using safe, effective methods and products." },
      ],
    },
    sampling: {
      tag: "Let's collaborate",
      title: "Free sampling.",
      text: "Want to evaluate our quality and precision? We offer a free sample of our services, with no obligation whatsoever.",
      cta: "Request a sample",
    },
    machinery: {
      overline: "04 — Technology & Machinery",
      title: "Quality above quantity. Always.",
      p: "We put quality above quantity, yet we are equipped to meet high-volume production needs too. We have an in-house turner-technician for custom clamps and moulds, usable both for our 4 Robots and for manual processing.",
      features: [
        "4 automated machining robots",
        "In-house turner-technician for bespoke clamps & moulds",
        "Individual quality checks on every single item",
        "Isolated area for delicate assembly & controlled environments",
      ],
    },
    sectors: {
      overline: "05 — Sectors Served",
      title: "Partner to industry leaders.",
      list: ["Furniture", "Bathroom Fittings", "Cycle & Motorcycle", "Automotive", "Nautical", "Medical Prosthetics"],
    },
    work: {
      overline: "06 — Our Workshop",
      title: "The work speaks for itself.",
    },
    contact: {
      overline: "07 — Contact",
      title: "Let's build something precise.",
      sub: "For information or to discuss a collaboration, contact Cristiano Olmi directly.",
      name: "Full name",
      email: "Email",
      company: "Company",
      phone: "Phone",
      message: "Your message",
      send: "Send request",
      sending: "Sending...",
      success: "Request sent! We'll get back to you shortly.",
      error: "Sending failed. Please retry or call us directly.",
      directTitle: "Direct contacts",
      addressLabel: "Headquarters",
      address: "Via Baccanello, 35 · 24030 Terno d'Isola (BG), Italy",
    },
    footer: { rights: "All rights reserved.", tagline: "High-precision machining since 1970.", download: "Download Company Profile" },
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("it");
  const toggle = useCallback((l) => setLang(l), []);
  const t = translations[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang: toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
